import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useUserStore } from "./userStore";
import BackupService from "../services/BackupService";
import { useAuth } from "./auth";
import { subscribe, unsubscribe } from "../utils/events";

const BackupContext = createContext({
	backup: null,
	isImporting: false,
});

export const BackupProvider = ({ children }) => {
	const [backup, setBackup] = useState(null);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isImporting, setIsImporting] = useState(false);
	const { selectedCondominio, selectedLicenceObj } = useUserStore();
	const { user } = useAuth();
	const [itemsError, setItemsError] = useState([]);
	const [modalLoadingIsOpen, setModalLoadingIsOpen] = useState(false);
	const [modalIsOpen, setIsOpen] = useState(false);

	function clearBackup() {
		setBackup(null)
		setError(null)
	}

	useEffect(() => {
		clearBackup();
		subscribe('onSseReceived', onSseReceived);
		return () => unsubscribe('onSseReceived', onSseReceived);
	}, [user])

	async function getBackup() {
		setIsLoading(true);
		const response = await BackupService.getCurrentImporting(selectedCondominio);
		console.log('backup: ', response);
		if (!response) return;
		setIsLoading(false);
		if (response.data) {
			setBackup(response.data);
			setIsImporting(true);
		} else {
			setBackup(null);
			setIsImporting(false);
		}
		return response.data;
	}

	async function importBackup(_backup, targetUnitId, replicationUnitIds, password, isMirrorMode, defaultUnitTag) {
		if (!_backup) return;
		setModalLoadingIsOpen(true);
		setIsImporting(true);
		setError(null);
		const response = await BackupService.import(_backup.id, targetUnitId, replicationUnitIds, password, isMirrorMode, defaultUnitTag);
		if (response.status !== 201) {
			setError("Ocorreu um erro ao importar o backup");
			return;
		}
		setBackup({
			..._backup,
			status: 4,
			currentStage: 0,
		});
	}

	useEffect(() => {
		if (!selectedCondominio) return;
		if (!backup || backup.serialNumber !== selectedLicenceObj.SN_equipment) {
			getBackup();
		}
	}, [selectedCondominio]);

	async function onSseReceived(ssePayload) {
		if (!user?.userData) return;
		const selectedCondominio = Number(user.userData.selectedUnitId);
		if (
			["backupImportStatus", "backupImportFinished"].includes(ssePayload?.action) && selectedCondominio === Number(ssePayload.content.unitId)
		) {
			let _backup = ssePayload.content.backup;
			if (_backup) {
				if (ssePayload.content.error) {
					setError(ssePayload.content.error.message ?? 'Ocorreu um erro');
					setIsImporting(false);
					return;
				}
				let currentStage = ssePayload.content.stage;
				if (ssePayload.action === "backupImportFinished") {
					const response = await BackupService.getImportationItemsError(_backup.currentImportExternalId);
					setItemsError(response?.data);
					currentStage = _backup.totalImportingStages;
					setIsImporting(false);
				}
				setBackup({
					..._backup,
					currentStage,
				});
			}
		}
	}

	return (
		<BackupContext.Provider value={{
			backup,
			importBackup,
			setBackup,
			error,
			setError,
			modalIsOpen,
			setIsOpen,
			clearBackup,
			itemsError,
			setItemsError,
			modalLoadingIsOpen,
			setModalLoadingIsOpen,
			isImporting,
			setIsImporting,
		}}>
			{children}
		</BackupContext.Provider>
	);
}

export function useBackup() {
	const context = useContext(BackupContext);
	return context;
}